<app-table
    #folderMedicalReports
    tableKey="folderMedicalReports"
    [gridData]="$any(store.data.getFolderMedicalReports())"
    [columns]="columns"
    translatePrefix="folder.medicalReports."
    [resource]="'doctorWork'"
    [showSearch]="true"
    [showButtonLabels]="true"
    [showColumnVisiblity]="true"
    [showCreate]="!folderStore.isTerminated() && store.isAllowed('doctorWork.create')()"
    [showDelete]="!folderStore.isTerminated()"
    (createCallback)="openDialog()"
    (detailCallback)="openDialog($event)"
    (deleteCallbackWithEvent)="delete($event)"
    [additionalFilter]="extraFilters()"
    [refreshCallback]="store.api.getFolderMedicalReports"
></app-table>
